import { createFileRoute } from '@tanstack/react-router'
import { SettingsShell } from '../../../modules/settings/settings-shell'
import { TeamsSettingsPage } from '../../../modules/settings/teams-settings-page'

export const Route = createFileRoute('/_authed/settings/teams')({
  component: () => (
    <SettingsShell>
      <TeamsSettingsPage />
    </SettingsShell>
  ),
})
